import { render, staticRenderFns } from "./CardTotalizador.vue?vue&type=template&id=2b6d270e&scoped=true"
import script from "./CardTotalizador.vue?vue&type=script&lang=js"
export * from "./CardTotalizador.vue?vue&type=script&lang=js"
import style0 from "./CardTotalizador.vue?vue&type=style&index=0&id=2b6d270e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6d270e",
  null
  
)

export default component.exports